import { PermanentJobsApi } from '../clients';
import { IDeleteShortlistCandidatePayload } from '../types';

export const deleteShortlistCandidate = async (
  payload: IDeleteShortlistCandidatePayload,
): Promise<void> => PermanentJobsApi.deleteShortlistCandidate(payload);
